'use client';

/**
 * Persona feed renderer. Shows a prominent "uncensored" banner over the raw
 * persona events (the full persona JSON — incl. hidden-truth / deception meta
 * the caller side normally never reveals — plus the grounding summaries),
 * then defers to JsonLogRenderer for the collapsible-tree view.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { JsonLogRenderer, type FeedRendererProps } from './JsonLogRenderer';

export function PersonaRenderer(props: FeedRendererProps) {
  return (
    <div className="flex h-full flex-col">
      <div className="flex items-start gap-2 border-b border-amber-900/40 bg-amber-950/40 px-2 py-1.5 text-[11px] text-amber-300">
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 flex-shrink-0" />
        <span>
          <strong>Uncensored.</strong> Includes the AI caller's hidden-truth / deception meta and full
          backstory — the caller side normally never reveals this. Visible to platform admins only.
        </span>
      </div>
      <div className="min-h-0 flex-1">
        <JsonLogRenderer {...props} />
      </div>
    </div>
  );
}

export default PersonaRenderer;
